<template>
  <v-dialog v-model="opened" persistent fullscreen>
    <v-container fluid class="d-flex justify-center primary" style="min-height: 100%;">
      <v-col cols="10" class="py-0">
        <v-row justify="center">
          <v-col v-if="mounted" cols="10" class="py-0">
              <SearchExternalPicker
                :service="service"
                :contentType="contentType"
                :onClickItem="handlePick"
                :filters="filters"
              ></SearchExternalPicker>
          </v-col>
          <v-btn 
            icon 
            @click="close"
            fixed
            top
            right
            class="mt-3 mr-5"
          >
            <v-icon color="white" size="35">
              close
            </v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-container>
  </v-dialog>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useStore } from "vue2-helpers/vuex";

import SearchExternalPicker from './SearchExternalPicker.vue';

// eslint-disable-next-line no-undef
const props = defineProps({
  opened: Boolean,
  field:  { type: Object, default(){ return {} } },
  handlePick: Function,
  close: Function,
  filters: { type: Array, default: () => [] }
});

const store = useStore();

const contentType = ref(store.state.rawContentTypes[props.field.type]);
const rawContentTypes = ref(store.state.rawContentTypes);
const content = ref({});
const mounted = ref(false);
const error = ref(null);
const service = ref("");

const resetData = () => {
  mounted.value = false
  contentType.value = store.state.rawContentTypes[props.field.type]
  service.value = props.field.pickerType
  rawContentTypes.value = store.state.rawContentTypes
  content.value = {}
  content.value.type = props.field.pickerType
  mounted.value = true
};

onMounted(() => {
  resetData();
});
</script>

<style lang="scss" scoped>

</style>
